import { UniqueId } from "../../common/GenerateId";
import { INotification, notificationType } from "./redux/Types";

export const PREPARE_TOAST_DISPLAYTIME = 10000;
export const ERROR_TOAST_DISPLAYTIME = 10000;

/**
 * Method to create notification object 
 */
export const createNotificationObject = (
  actionType: string,
  text: string,
  typeOfNotification: notificationType,
  autoDeleteIn?: number): INotification => {
  return {
    actionType: actionType,
    id: UniqueId(),
    text: text,
    type: typeOfNotification,
    autoCloseTime: autoDeleteIn,
  };
};

